export default "__VITE_ASSET__BxBF8yqA__"